// Estandarte de fundador: emblema distintivo (rojo marca + sello dorado) con el
// número de fundador. Es UNA sola pieza visual para toda la app — Home, perfil,
// dashboards, perfiles públicos y listas — para que "Fundador #N" se reconozca
// como un símbolo y no como un chip más.
// Uso: <FounderBadge n={7} size="sm|md|lg" /> — sin `n` muestra solo "Fundador".
// `text` permite un rótulo custom (ej. "Cliente Fundador #1" en la waitlist).
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';

const GOLD = '#FFC94D';

const SIZES = {
  sm: { pad: '2px 9px',   font: 10, icon: 11, gap: 5, radius: '999px' },
  md: { pad: '5px 13px',  font: 12, icon: 14, gap: 6, radius: '999px' },
  lg: { pad: '10px 22px', font: 15, icon: 18, gap: 8, radius: '14px' },
};

export default function FounderBadge({ n, size = 'md', text, style }) {
  const { t } = useTranslation();
  const s = SIZES[size] || SIZES.md;
  const label = text || (n ? t('launch.founderBadgeN', { n }) : t('launch.founderBadge'));
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: `${s.gap}px`,
      padding: s.pad, borderRadius: s.radius,
      background: 'linear-gradient(135deg, #E62117 0%, #8f1009 100%)',
      border: `1px solid ${GOLD}`,
      boxShadow: '0 1px 6px rgba(230,33,23,0.35)',
      color: '#fff', fontWeight: 800, fontSize: `${s.font}px`,
      letterSpacing: '0.6px', textTransform: 'uppercase', whiteSpace: 'nowrap',
      lineHeight: 1.4, verticalAlign: 'middle',
      ...style,
    }}>
      <Award size={s.icon} color={GOLD} style={{ flexShrink: 0 }} />
      {label}
    </span>
  );
}
